<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<!--<p-table #pt [value]="properties" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,200,400]" [lazy]="true"
	(onEditInit)="onCellEditInit($event)" (onEditComplete)="onCellEditComplete($event)"	(onEditCancel)="onCellEditCancel()"
	(onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
	selectionMode="single" [(selection)]="property" dataKey="shortTermRentalId" (onRowSelect)="onRowSelect($event)"
	[loading]="loading" styleClass="property-list-table p-datatable-striped" [ngStyle]="{'width': 'auto'}">-->

<p-table #pt [value]="descriptions" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="testId"
	(onEditInit)="onCellEditInit($event)" (onEditComplete)="onCellEditComplete($event)"
	(onEditCancel)="onCellEditCancel()" selectionMode="single" [(selection)]="description"
	(onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="true" [rows]="25"
	[rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
	currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
	sortMode="multiple" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
	[autoLayout]="true" [responsive]="true">
	<ng-template pTemplate="caption"> <i class="fa fa-search" style="margin:4px 4px 0 0;"></i>
		<span style="float:left">
		</span>
		<span style="float:right">
			<!--clear filters-->
			<button pButton pRipple class="p-button-text"
				style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
				(click)="reloadPage()">Clear Filters</button>
		</span>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th [pSortableColumn]="'shortTermRentalId'">
				<p-sortIcon [field]="'shortTermRentalId'"></p-sortIcon>strId
			</th>
			<th [pSortableColumn]="'locationId'">
				<p-sortIcon [field]="'locationId'"></p-sortIcon>Location
			</th>
			<th [pSortableColumn]="'developmentVO.addressDevelopmentName'">
				<p-sortIcon [field]="'developmentVO.addressDevelopmentName'"></p-sortIcon>Development
			</th>
			<th [pSortableColumn]="'propertyCode'">
				<p-sortIcon [field]="'propertyCode'"></p-sortIcon>Property
			</th>
			<th [pSortableColumn]="'addressUnit'">
				<p-sortIcon [field]="'addressUnit'"></p-sortIcon>Unit
			</th>

			<th [pSortableColumn]="'featureDescVO.headlineChannelDefault'">
				<p-sortIcon [field]="'featureDescVO.headlineChannelDefault'"></p-sortIcon>Channel Headline Default
			</th>
			<th [pSortableColumn]="'featureDescVO.headlineChannelSpecialOffer'">
				<p-sortIcon [field]="'featureDescVO.headlineChannelSpecialOffer'"></p-sortIcon>Channel Headline Special
			</th>
		</tr>

		<tr>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="number"
					(input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
			<th>
				<p-dropdown [style]="{'width':'50px','min-width':'100%'}" [options]="locationIds"
					(onChange)="pt.filter($event.value, 'locationId', 'in')" styleClass="p-column-filter"
					placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value"
					[value]="pt.filters['locationId'] ? pt.filters['locationId'].value : ''" appendTo="body">
					<ng-template let-option pTemplate="item">
						<span>{{option.name}}</span>
					</ng-template>
				</p-dropdown>
			</th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'developmentVO.adrDevelopmentName', 'in')"></th>

			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'propertyCode', 'in')"
					[value]="pt.filters['propertyCode'] ? pt.filters['propertyCode'].value : ''"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'addressUnit', 'in')"></th>

			<th>
				<input pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'featureDescVO.headlineChannelDefault', 'in')">
			</th>
			<th>
				<input pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'featureDescVO.headlineChannelSpecialOffer', 'in')">
			</th>
		</tr>
	</ng-template>
	
	
	
	<ng-template pTemplate="body" let-description>
		<tr [pEditableRow]="description">
			<td><a href="/property-edit/{{description.shortTermRentalId}}" target="_blank">
					<i class="pi pi-pencil" aria-hidden="true"
						style="color:blue; font-size:110%; padding-right:20px;"></i>&nbsp;&nbsp;{{description?.shortTermRentalId}}
				</a></td>
			<td>{{Locations[description['locationId']] }}</td>
			<td>{{description?.adrDevelopmentName}}</td>
			<td><a href="/property-edit/{{description.shortTermRentalId}}"
					target="_blank">{{description?.propertyCode}}</a>
			</td>
			<td>{{description?.adrUnit}}</td>

			<td [pEditableColumn]="description" [pEditableColumnField]="'headlineChannelDefault'">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<textarea pInputTextarea placeholder="Write something..." maxlength="80"
							(keyUp.backspace)="onKeyup($event)" (keypress)="maxLength($event)"
							[(ngModel)]="description.headlineChannelDefault" class="addNotes" style="width:90%">
						</textarea>
						<span>{{notesLength}}/80</span>
					</ng-template>
					<ng-template pTemplate="output">
						{{description?.headlineChannelDefault}}
					</ng-template>
				</p-cellEditor>
			</td>
			<td [pEditableColumn]="description" [pEditableColumnField]="'headlineChannelSpecialOffer'">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<textarea pInputTextarea placeholder="Write something..." maxlength="80"
							(keyUp.backspace)="onKeyup($event)" (keypress)="maxLength($event)"
							[(ngModel)]="description.headlineChannelSpecialOffer" class="addNotes" style="width:90%">
						</textarea>
						<span>{{notesLength}}/80</span>
					</ng-template>
					<ng-template pTemplate="output">
						{{description?.headlineChannelSpecialOffer}}
					</ng-template>
				</p-cellEditor>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
			{{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
				lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>